import { useIntl } from "react-intl";

import { classNames } from "helpers/commonHelpers";
import type { GoodCustomsInformation } from "@RequestFormV2/sections/PackingList/types";
import { formatCommodityValue } from "@RequestFormV2/components/ReviewPage/sections/ReviewPackingList/reviewPackingListFormatters";

type ReviewPackingListCommodityCellProps = {
  commodities: GoodCustomsInformation[];
};

function CommodityBlock({ commodity, showDivider }: { commodity: GoodCustomsInformation; showDivider: boolean }) {
  const intl = useIntl();
  const formattedValue = formatCommodityValue(commodity);

  return (
    <div
      className={classNames("rfv2-review-packing-list__commodity-block", {
        "rfv2-review-packing-list__commodity-block--divider": showDivider,
      })}
    >
      {commodity.description && (
        <span className="rfv2-review-packing-list__commodity-description">{commodity.description}</span>
      )}
      {commodity.hs_code && (
        <span className="rfv2-review-packing-list__commodity-hs-code">
          <span className="rfv2-review-packing-list__commodity-hs-code-label">
            {intl.formatMessage({
              id: "request-form.review.packingList.hsCode",
              defaultMessage: "HS Code:",
            })}{" "}
          </span>
          <span className="rfv2-review-packing-list__commodity-hs-code-value">{commodity.hs_code}</span>
        </span>
      )}
      {formattedValue && (
        <div className="rfv2-review-packing-list__commodity-value">
          <span className="rfv2-review-packing-list__commodity-currency">{commodity.currency_code ?? "USD"}</span>
          <span className="rfv2-review-packing-list__commodity-amount">{formattedValue}</span>
        </div>
      )}
    </div>
  );
}

export default function ReviewPackingListCommodityCell({ commodities }: ReviewPackingListCommodityCellProps) {
  if (commodities.length === 0) {
    return <span>-</span>;
  }

  return (
    <div className="rfv2-review-packing-list__commodity-cell">
      {commodities.map((commodity, index) => (
        <CommodityBlock
          key={commodity.commodity_key ?? index}
          commodity={commodity}
          showDivider={index < commodities.length - 1}
        />
      ))}
    </div>
  );
}
